import { AbstractControl, ValidationErrors } from '@angular/forms';

export function validateNumber(event: any): void {
  const input = event.target.value;

  // Allow input of just a single '-' or '.' at the start
  if (input === '-' || input === '.') {
    return;
  }

  // Regex to match a valid negative or positive decimal number
  const validNumber = /^-?\d*\.?\d*$/;

  // If input doesn't match the valid number pattern, revert to the previous valid value
  if (!validNumber.test(input)) {
    // Remove the last character that was just entered
    event.target.value = input.slice(0, -1);
  }
}

export function sanitizeHexColor(input: string): string {
  let value = input.trim().toLowerCase();

  value = value.replace(/[^#0-9a-fA-F]/g, '');

  if (!value.startsWith('#')) {
    value = '#' + value;
  }

  return value.length > 7 ? value.substring(0, 7) : value;
}

export function isValidHexColor(input: string): boolean {
  const hexPattern = /^#([0-9a-fA-F]{6})$/;
  return hexPattern.test(input);
}

export function greaterThanZero(control: AbstractControl): ValidationErrors | null {
  return control.value !== null && control.value <= 0 ? { min: true } : null;
}

export function isOnlyInactiveSelected(control: AbstractControl): ValidationErrors | null {
  const val = control.value as number[];
  return val?.length > 0 && val.every(v => v === -1) ? { onlyInactive: true } : null;
}

export const PRICE_PATTERN = /^\d{1,7}(\.\d{1,2})?$/;
